var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"id":"link","to":_vm.to,"fab":_vm.fab,"x-small":"","text":"","color":"light-blue"}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.icon)?_c('v-icon',{attrs:{"x-small":""}},[_vm._v("mdi-"+_vm._s(_vm.icon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }